export default {
      id: "x-icon-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite-46b249.svg#x-icon-usage",
      toString: function () {
        return this.url;
      }
    }